// eslint-disable-next-line @typescript-eslint/no-var-requires
const routes = require('src/routing/routes').default

export const myZonePages = {
    MyContracts: {
        path: routes.myContracts.path,
        comp: () => import('src/business/my-zone/my-contracts/MyContractsPage'),
        to: (): string => routes.myContracts.path
    },
    CancelContract: {
        path: routes.cancelContract.path,
        comp: () => import('src/business/my-zone/CancelContractPage'),
        to: (p: { id: number }): string => `/my/contracts/${p.id}/cancel`
    },
    MyContractDetail: {
        path: routes.myContractDetail.path,
        comp: () => import('src/business/my-zone/detail/MyContractDetailPage'),
        to: (p: { id: number }): string => `/my/contracts/${p.id}`
    },
    MyProfile: {
        path: routes.myProfile.path,
        comp: () => import('src/business/my-zone/my-profile/MyProfilePage'),
        to: (): string => routes.myProfile.path
    },
    RemoveAccount: {
        path: routes.deleteAccount.path,
        comp: () => import('src/business/my-zone/DeleteAccountPage'),
        to: (): string => routes.deleteAccount.path
    },
    MyBoxes: {
        path: routes.myBoxes.path,
        comp: () => import('src/business/my-zone/my-boxes/MyBoxesPage'),
        to: (): string => routes.myBoxes.path
    },
    ChangePassword: {
        path: routes.changePassword.path,
        comp: () => import('src/business/my-zone/ChangePasswordPage'),
        to: (): string => routes.changePassword.path
    },
    MyRents: {
        path: routes.myRents.path,
        comp: () => import('src/business/my-zone/MyRentsPage'),
        to: (): string => routes.myRents.path
    },
    ConfirmEviction: {
        path: routes.confirmEviction.path,
        comp: () => import('src/business/my-zone/ConfirmEvictionContractPage'),
        to: (p: { id: number }): string => `/my/contracts/${p.id}/eviction`
    }
}
